import { render, staticRenderFns } from "./User-Details.vue?vue&type=template&id=b0f61470&scoped=true"
import script from "./User-Details.vue?vue&type=script&lang=js"
export * from "./User-Details.vue?vue&type=script&lang=js"
import style0 from "./User-Details.vue?vue&type=style&index=0&id=b0f61470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f61470",
  null
  
)

export default component.exports